/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    young<yangyang@frippler.com>
  | @Title:     模型管理-品牌 API
  | @Version:   2019-03-08  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getAllMappingApi(params) {
  return request({
    url: '?c=dev&a=private-mapping&do=getall',
    method: 'get',
    params
  })
}

export function getMappingListApi(params) {
  return request({
    url: '?c=dev&a=private-mapping&do=list',
    method: 'get',
    params
  })
}

export function getMappingApi(params) {
  return request({
    url: '?c=dev&a=private-mapping&do=get',
    method: 'post',
    params
  })
}

export function postMappingApi(data) {
  return request({
    url: '?c=dev&a=private-mapping&do=post',
    method: 'post',
    data
  })
}

export function deleteMappingApi(data) {
  return request({
    url: '?c=dev&a=private-mapping&do=delete',
    method: 'post',
    data
  })
}

export function rankMappingApi(data) {
  return request({
    url: '?c=dev&a=private-mapping&do=displayorder',
    method: 'post',
    data
  })
}
